import { fetchWebhooks, type ApiListResponse, type ApiWebhookEndpoint } from "@/lib/api";
import { useApiQuery } from "@/hooks/use-api";

const EMPTY_WEBHOOKS: ApiWebhookEndpoint[] = [];

function mapWebhookResponse(raw: ApiListResponse<ApiWebhookEndpoint>) {
  return {
    data: raw.items,
    error: raw.error,
    isEmpty: raw.items.length === 0,
  };
}

export function useWebhooks(enabled: boolean) {
  const result = useApiQuery(
    fetchWebhooks,
    mapWebhookResponse,
    { initialData: EMPTY_WEBHOOKS, enabled },
  );

  return {
    webhooks: result.data,
    loading: result.loading,
    error: result.error,
    refresh: result.refresh,
  };
}
